import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import ScreenFit from "./top-nav-bar";

const url = `https://api.themoviedb.org/3`;

export const Movies = () => {
  const [movies, setMovies] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [page, setPage] = useState(0);

  const [searchItem, setSearchItem] = useState("");

  //Fetching data

  const displayMovies = async (title) => {
    const {
      data: { results },
    } = await axios.get(`${url}/discover/movie`, {
      params: {
        api_key: "133491eb932bc05b080e6654ae7dfef9",
      },
    });

    setMovies(results);

    setIsLoading(false);
  };

  useEffect(() => {
    displayMovies();
  }, []);

  const moviesPerPage = 6;

  const pageVisited = page * moviesPerPage;

  const pageCount = Math.ceil(movies.length / moviesPerPage);

  const changePage = ({ selected }) => {
    setPage(selected);
  };

  return (
    <>
      <ScreenFit movies={movies} setMovies={setMovies} />
      <section className="movies" style={{ padding: "4rem" }}>
        <div className="movies-search-wrapper">
          <div className="movies-search">
            <form action=""  style={{display:'flex'}}>
              <input
                type="text"
                name=""
                id=""
                placeholder="Search for your favorite movies...   "
                value={searchItem}
                onChange={(e) => setSearchItem(e.target.value)}
                
              />
      
            </form>
          </div>
        </div>

        <h3>{isLoading ? "Loading..." : null}</h3>
        <div className="some-div-wrapper">
          
        </div>

        <div className="main-wrapper" style={{ display: "grid", gap: "3rem" }}>
          {movies
            ? movies
                .filter((movie) =>
                  movie.title.toLowerCase().includes(searchItem)
                )

                .slice(pageVisited, pageVisited + moviesPerPage)

                .map((movie) => {
                  const { id, title, poster_path, vote_average, release_date } =
                    movie;

                  const image = "https://image.tmdb.org/t/p/w500";

                  return (
                    <section key={id}>
                      <div className="movies-wrapper">
                        <div className="movie-wrapper-item">
                          {poster_path ? (
                            <img src={`${image}${poster_path}`} alt="" />
                          ) : null}

                          <h3>{title}</h3>
                          <h4>Relese Date : {release_date}</h4>
                          <h4>Ratings : {vote_average}</h4>
                        </div>
                      </div>
                    </section>
                  );
                })
            : "No results"}
        </div>

        {isLoading ? null : (
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttns"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          ></ReactPaginate>
        )}
      </section>
    </>
  );
};

export default Movies;
